import React from 'react'

import * as S from './styles'

export type BoxPremiumProps = {
    title: string
    content: string
}

const BoxPremium = ({ title, content}: BoxPremiumProps) => {
    return (
        <S.Wrapper>
            <S.ArrowRight />
            <S.Title>{title}</S.Title>
            <S.Content dangerouslySetInnerHTML={{__html: content}} />
        </S.Wrapper>
    )
}

export default BoxPremium